import { InjectionToken, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { filter, tap } from 'rxjs/operators';

export const MODULE_URL_TOKEN = new InjectionToken<string>(
  'ModuleRootUrlToken'
);
